export function capitalize(value, keepOriginalCase = true) {
  if (typeof value !== 'string' || value.length === 0) {
    return '';
  }
  const normalized = keepOriginalCase ? value : value.toLowerCase();
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function truncateText({ text, maxLength = 20 }) {
  if (typeof text !== 'string') {
    return '';
  }
  if (maxLength <= 0 || text.length <= maxLength) {
    return text;
  }
  return `${text.slice(0, maxLength)}...`;
}

export function DynamicTruncateText(text, maxLength = 20) {
  if (typeof text !== 'string') {
    return '';
  }
  if (!Number.isFinite(maxLength) || maxLength <= 0) {
    return text;
  }
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
}

export function mergedRefs(...refs) {
  return value => {
    refs.forEach(ref => {
      if (!ref) {
        return;
      }
      if (typeof ref === 'function') {
        ref(value);
      } else {
        ref.current = value;
      }
    });
  };
}

export function formatTime(seconds = 0) {
  const totalSeconds = Math.max(0, Math.floor(Number(seconds) || 0));
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}

export function globalDateFormat(value, format = 'DD MMM YYYY') {
  if (!value) {
    return '';
  }

  const parsed = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return '';
  }

  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const tokenMap = {
    DD: String(parsed.getDate()).padStart(2, '0'),
    MM: String(parsed.getMonth() + 1).padStart(2, '0'),
    MMM: monthNames[parsed.getMonth()],
    YYYY: String(parsed.getFullYear()),
    YY: String(parsed.getFullYear()).slice(-2),
  };

  return String(format).replace(/YYYY|MMM|MM|DD|YY/g, token => tokenMap[token] ?? token);
}

export function encodeId(id) {
  return encodeURIComponent(String(id ?? ''));
}

export function decodeId(value) {
  try {
    return decodeURIComponent(String(value ?? ''));
  } catch (_error) {
    return String(value ?? '');
  }
}

export function getHomePath() {
  return '/';
}

export const formatOtpTime = seconds => {
  if (seconds > 60) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}${t('unit.m', { ns: 'common' })} ${secs}${t('unit.s', { ns: 'common' })}`;
  }
  return `${seconds}s`;
};
